module.exports = __webpack_public_path__ + "public/SiteIcons/starFill.svg?9f941bc3";